<div class="app-view-containerfull">
  <div class="main-actions">
    <div class="actions-container action-box w-full flex flex-row justify-end place-items-center mb-8">
      <div class="action-box actions-left">
        <button mat-flat-button *ngIf="assetsDetailList?.length" (click)="clearBasket('clear', $event)" class="button-primary" type="button">
          <mat-icon><span class="material-icons-outlined">remove_shopping_cart</span></mat-icon>
          <span class="px-2 font-bold" i18n>Clear Basket</span>
        </button>
        <button mat-flat-button (click)="addToCollection()" *ngIf="assetsDetailList?.length" class="button-primary" type="button">
          <mat-icon><span class="material-icons-outlined">add_box</span></mat-icon>
          <span class="px-2 font-bold" i18n>Add to Collection</span>
        </button>

        <thehubz-asset-bulk-edit
          *ngIf="assetsDetailList?.length"
          [bulkEditType]="'basket'"
          [filteredAssets]="filteredList"
          (toggleSelectAllCheckbox)="clearBasket('unselect', $event)"
          (clickClearBasket)="clearBasket('clear', $event)"
        ></thehubz-asset-bulk-edit>
      </div>
      <div class="actions-right" *ngIf="assetsDetailList?.length">
        <sp-search-field
          [maxWidth]="'400px'"
          (keyUpInput)="searchTextChanged($event)"
          (clearInput)="clearSearch($event)"
          [placeholder]="searchPlaceholder"
          (toggleMobileSearch)="toggleMobileSearch()"
        ></sp-search-field>
        <div class="filter-box pl-2 relative">
          <button mat-flat-button class="button-primary" [matMenuTriggerFor]="filterMenu" #menuTrigger>
            <mat-icon class="material-icons-outlined">filter_alt</mat-icon>
            <span class="px-2 font-bold">
              <ng-container i18n>Filter</ng-container>&nbsp;<span *ngIf="appliedFilters">({{ appliedFilters }})</span>
            </span>
          </button>
          <mat-menu #filterMenu="matMenu" class="filter-popup-box">
            <thehubz-asset-filter (clickApplyFilter)="applyFilters($event)"></thehubz-asset-filter>
          </mat-menu>
        </div>
      </div>
    </div>
    <div class="mobile-search" [ngClass]="{ 'is-open': isMobileSearchOpen }" (window:resize)="onEvent($event)" (focusout)="onEvent($event)" tabindex="1">
      <sp-search-field
        [searchText]="searchText"
        [maxWidth]="''"
        (keyUpInput)="searchTextChanged($event)"
        (clearInput)="clearSearch($event)"
        [placeholder]="searchPlaceholder"
        [mobileSearch]="true"
      ></sp-search-field>
    </div>
  </div>
  <div class="app-content-container">
    <!-- To show loading message, while http call is in progress -->
    <sp-loading-inprogress *ngIf="httpCallInProgress; else loadingComplete" [showSpinner]="true"></sp-loading-inprogress>
    <ng-template #loadingComplete>
      <ng-container *ngIf="basketDataLoaded" class="flex flex-row h-full">
        <div *ngFor="let asset of filteredList; let i = index" class="card w-full sm:w-1/2 lg:w-1/3 xl:w-1/4 h-auto inline-block">
          <div class="h-auto mr-6 mb-6 bg-white rounded-lg shadow-lg hover:shadow-xl relative">
            <div (click)="openAssetPage(asset._id)" class="relative asset-image-box h-[220px] w-full flex items-center cursor-pointer rounded-lg overflow-hidden">
              <!-- Disabling pointer events on expired images, to hide the 'save as image' menu on right click -->
              <a (click)="updateAssetList()" [routerLink]="asset._id | assetLink" class="object-contain h-full w-full m-auto">
                <img
                  *ngIf="asset.imageUrl"
                  class="object-contain h-full m-auto"
                  [src]="asset.imageUrl | imageLoading | async"
                  [alt]="asset.name"
                  [style.pointerEvents]="!(asset.expiryDate | dateNotExpired) ? 'none' : 'all'"
                />
                <div class="h-full w-full flex justify-center items-center" *ngIf="!asset.previewUrl && (asset.expiryDate | dateNotExpired)">
                  <span class="text-xl font-bold" i18n>Preview Not Available</span>
                </div>
                <!-- Overlay for expired assets  -->
                <sp-overlay class="asset-overlay-semitransparent top-0" *ngIf="!(asset.expiryDate | dateNotExpired)">
                  <span class="text-xl font-bold">Expired</span>
                </sp-overlay>
              </a>
              <div class="absolute top-4 left-4">
                <mat-checkbox class="example-margin" (change)="removeFromBasket(asset._id, $event)" (click)="$event.stopPropagation()" [checked]="asset ? true : false"> </mat-checkbox>
              </div>
            </div>
            <p class="flex justify-between pl-6 pt-1 w-[95%]">
              <span class="truncate pr-4">{{ asset.name }}</span>
              <sp-expiry-days-warning [asset]="asset"></sp-expiry-days-warning>
            </p>
            <div class="flex justify-between pt-2 pb-1">
              <div class="flex justify-center items-center ml-3">
                <mat-icon class="material-icons-outlined" [svgIcon]="assetCommonService.getIcon(asset.assetType)" i18n-matTooltip [matTooltip]="asset.assetType"></mat-icon>
              </div>

              <div class="flex justify-between pt-2 pb-1">
                <div>
                  <span class="cursor-pointer" *ngIf="false" matTooltip="Delete">
                    <button mat-icon-button [disabled]="asset.inProgress">
                      <mat-icon>
                        <span class="material-icons-outlined">delete_outline</span>
                      </mat-icon>
                    </button>
                  </span>
                  <span class="cursor-pointer" *ngIf="asset.expiryDate | dateNotExpired">
                    <button mat-icon-button type="button" i18n-matTooltip matTooltip="Download asset" (click)="downloadAsset(asset)">
                      <mat-icon>
                        <span class="material-icons-outlined">file_download</span>
                      </mat-icon>
                    </button>
                  </span>
                  <span class="pr-2 cursor-pointer">
                    <button mat-icon-button type="button" i18n-matTooltip matTooltip="Remove from basket" (click)="removeFromBasket(asset._id, $event); $event.stopPropagation()">
                      <mat-icon>
                        <span class="material-icons-outlined"> remove_shopping_cart </span>
                      </mat-icon>
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="basketDataLoaded && !filteredList.length" class="h-[85%] pr-3 overflow-hidden !h-40">
        <sp-blank-page *ngIf="!appliedFilters && !filterDetails.name" pageType="asset-basket"></sp-blank-page>
        <div *ngIf="appliedFilters || filterDetails.name" i18n>No assets found base on filter</div>
      </ng-container>
    </ng-template>
  </div>
</div>
